import type { FullTranslation } from "../../lib/i18n"

export const EXPORT_SETTINGS_T = {
  title: { FR: "Colonnes de l'export", EN: "Export columns" },
  hint: {
    FR: "Cochez les colonnes à garder et renommez-les si besoin. S'applique à toute l'équipe et à chaque fichier : téléchargements CSV, Excel et JSON, fichiers envoyés par email et livraison hebdomadaire.",
    EN: "Tick the columns to keep and rename them if needed. Applies to the whole team and to every file: CSV, Excel and JSON downloads, emailed files and the weekly delivery.",
  },
  layoutLabel: { FR: "Contacts", EN: "Contacts" },
  layoutPerContact: { FR: "Une ligne par contact", EN: "One row per contact" },
  layoutPerCompany: {
    FR: "Une ligne par entreprise",
    EN: "One row per company",
  },
  layoutPerContactHint: {
    FR: "Une entreprise avec 3 contacts donne 3 lignes, ses colonnes répétées.",
    EN: "A company with 3 contacts gives 3 rows, its columns repeated.",
  },
  layoutPerCompanyHint: {
    FR: "Tous les contacts dans les mêmes cellules : chaque valeur une seule fois, séparée par « ; » (tous les e-mails, tous les téléphones).",
    EN: 'Every contact in the same cells: each value once, separated by "; " (every email, every phone).',
  },
  search: { FR: "Rechercher une colonne", EN: "Search a column" },
  count: {
    FR: "{kept} colonnes sur {total}",
    EN: "{kept} of {total} columns",
  },
  groupSheet: { FR: "Fiche de prospection", EN: "Pitch sheet" },
  groupDetails: { FR: "Détails de l'audit", EN: "Audit details" },
  groupData: { FR: "Données brutes", EN: "Raw data" },
  rename: {
    FR: "Nouveau nom de la colonne {column}",
    EN: "New name of column {column}",
  },
  renamePlaceholder: { FR: "Renommer…", EN: "Rename…" },
  columnInfo: {
    FR: "Ce que contient la colonne {column}",
    EN: "What column {column} holds",
  },
  duplicate: {
    FR: "Une autre colonne porte déjà ce nom.",
    EN: "Another column already has this name.",
  },
  noMatch: {
    FR: "Aucune colonne ne correspond.",
    EN: "No column matches.",
  },
  reset: { FR: "Tout réinitialiser", EN: "Reset all" },
  save: { FR: "Enregistrer", EN: "Save" },
  saved: {
    FR: "Réglages de l'export enregistrés.",
    EN: "Export settings saved.",
  },
  failedToLoad: { FR: "Échec du chargement.", EN: "Failed to load." },
} satisfies FullTranslation
